import styled from '../../../styled';
const Head = styled.div `
  display: flex;
  border-bottom: 0.0625rem solid #d3dde6;
  margin-top: 1rem;
  font-size: 0.8125rem;
  font-weight: 500;
  line-height: 1.25rem;

  > div {
    padding: 0.5rem;
    flex-grow: 1;
  }
`;
const HeadCell = styled.div `
  padding: 0.5rem;
  width: ${({ width }) => width || '6.625rem'};
`;
export default Head;
export { HeadCell };
//# sourceMappingURL=Head.js.map